import { http, HttpResponse } from "msw";
const mockLogContent = `[2025-08-25T18:55:00.000Z] INFO: Server starting up...
[2025-08-25T18:55:01.123Z] DEBUG: This is a debug statement...
[2025-08-25T18:55:01.456Z] INFO: This is some information.
`;
const handler = http.get("/api/admin/logs", ()=>{
    const blob = new Blob([
        mockLogContent
    ], {
        type: "application/gzip"
    });
    return new HttpResponse(blob, {
        status: 200,
        headers: {
            "Content-Type": "application/gzip",
            "Content-Disposition": `attachment; filename="logs.tar.gz"`
        }
    });
});
export default handler;
